{
  "title": "ŞANS ÇARXI",
  "description": "Hər gün şansını sına!",
  "available": "Bugünkü pulsuz şansın hazırdır!",
  "spin": "🎡 FIRLAT",
  "spinning": "Çarx fırlanır...",
  "winTitle": "Təbriklər!",
  "win": "{{amount}} AZN bonus qazandın!",
  "used": "🎁 Bugünkü şansından istifadə etdin! Sabah yenə gəl!",
  "homeCta": "Çarxa toxun və şansını sına",
  "homeUsed": "Sabah yenidən gəl!",
  "ribbonReady": "ŞANSINI SINA",
  "ribbonUsed": "SABAH YENƏ GƏL",
  "hubSpin": "FIRLAT",
  "sheetHint": "Çarxa toxun və şansını sına",
  "winAmount": "{{amount}} AZN QAZANDIN!",
  "closeResult": "Bağla",
  "demoBadge": "Vizual nümayiş — real bonus hələ aktiv deyil",
  "loginRequiredBadge": "Real bonus üçün hesabınıza daxil olun",
  "loginRequired": "Real Şans Çarxı üçün giriş edin.",
  "demoWinNote": "Bu yalnız vizual nəticədir. Bonus balansına kredit olunmayıb.",
  "testBadge": "SAYTIN TEST REJİMİ — TEST BONUS, çıxarılmır",
  "testWinNote": "{{amount}} AZN TEST BONUS kredit olundu. Bu vəsait çıxarıla bilməz və real balansa əlavə olunmur.",
  "testBalance": "Test bonus",
  "testLedger": "TEST BONUS (çıxarılmır)",
  "testNotWithdrawable": "Test vəsaiti heç vaxt çıxarıla bilməz",
  "testExpires": "Test müddəti bitir: {{when}}",
  "testPrize": "Test mükafat: {{amount}} AZN",
  "mute": "Səsi bağla",
  "unmute": "Səsi aç",
  "close": "Bağla",
  "openAria": "VBB ŞANS ÇARXI-nı aç",
  "spinFailed": "Fırlatma baş tutmadı. Bir az sonra yenidən cəhd et.",
  "wageringTitle": "Bonus çevrilməsi",
  "bonusBalance": "Bonus balansı",
  "wageringMultiplier": "Tələb",
  "wageringMultiplierValue": "{{count}}x",
  "wageringTarget": "Mərc tələbi",
  "wageringCompleted": "Tamamlanan",
  "wageringRemaining": "Qalan",
  "bonusStatus": "Bonus statusu",
  "withdrawalEligibility": "Çıxarış",
  "bonusNotWithdrawable": "Bonus vəsaiti çevrilmə təsdiqlənənə qədər çıxarıla bilməz"
}
